/** @flow */

import type { EmployeeIdentityState } from "./types";

export const initialState: EmployeeIdentityState = {
  requestsInProgress: 0,
  error: null,
  employeeIdentityData: {
    selfServiceEnabled: false,
    isLocked: false,
    identityVerificationCheck: [],
    processForFailedSecurityQuestion: 0,
    securityQuestionsEnabled: [],
    permittedToCreateNewEmployeeRecords: false,
    thirdPartyConsent: false,
    changeSetState: "",
    notificationAuditEnabled: false,
    notificationAuditFrequency: 90,
  },
  changeSet: null,
  modals: {
    mainOptions: {
      visible: false,
    },
    securityQuestions: {
      visible: false,
    },
    accessAudit: {
      visible: false,
    },
  },
  schema: null,
};

export default initialState;
